import { WithRequired } from '../../types';

export const hasRequiredProperty = <T, K extends keyof T>(data: T, property: K): data is WithRequired<T, K> => {
  return data[property] !== undefined;
};
